// Validate email address
// https://stackoverflow.com/a/32686261/4927236
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const stringIsValidEmail = (str) => {
  return emailRegex.test(str);
};
